import {
  SpaceBetween,
  Container,
  TextContent,
  FormField,
  Textarea,
  ColumnLayout,
  Box,
  Button,
} from "@cloudscape-design/components-themed";
import { useState } from "react";
import { useNavigate, useLocation, useParams } from "react-router-dom";
import { useAppDispatch } from "../../app/hook";
import { usePutApplicationRejectMutation } from "../../features/api";
import { ApplicationRejectRequest } from "../../features/api-interfaces";
import { getMessage } from "../../features/error/messages";
import { isLengthValid, isNull } from "../../utils/inputValidation";
import { showModal } from "../UI/modal/modal-slice";
import { COMMON_LABELS } from "../default-constants";
import { INPUT_MAX_LENGTH, LABELS, PROCESS_TYPE_INPUT } from "./constants";

export interface ICompany {
  corporateNumber?: string;
  companyName?: string;
  address?: string;
  merchantName?: string;
}

/*
 * 申請不備理由登録画面
 */
export const ApplicationIncompletionReasonRegister = () => {
  const navigator = useNavigate();
  const dispatch = useAppDispatch();
  const location = useLocation();
  const company = location.state as ICompany;
  const { applicationNo } = useParams();
  const [incompletionReason, setIncompletionReason] = useState("");
  const [incompletionReasonErrorMsg, setIncompletionReasonErrorMsg] =
    useState("");
  const [rejectApplication] = usePutApplicationRejectMutation();

  /**
   * 不備理由の入力ハンドラ.
   * @param {string} input
   */
  const incompletionReasonOnChange = (input: string) => {
    setIncompletionReason(input);
    const errorMsg = isLengthValid(input, INPUT_MAX_LENGTH)
      ? ""
      : getMessage("KGRERR058", 500).label;
    setIncompletionReasonErrorMsg(errorMsg);
  };

  /**
   * 登録ボタンを押したときの処理.
   */
  const registerOnClick = () => {
    if (isNull(incompletionReason)) {
      setIncompletionReasonErrorMsg(
        getMessage("KGRERR023", LABELS.INCOMPLETION_REASON).label
      );
      return;
    } else if (!isLengthValid(incompletionReason, INPUT_MAX_LENGTH)) {
      return;
    }
    dispatch(
      showModal({
        content: COMMON_LABELS.CONTENTS.REGISTER_CONFIRM,
        positiveFn: () => {
          const request: ApplicationRejectRequest = {
            applicationNo: applicationNo ?? "",
            processType: PROCESS_TYPE_INPUT,
            incompletionReason,
          };
          rejectApplication(request).then((result) => {
            if (!("error" in result) && "error" !== result.data.status) {
              navigator(`/application-status/${applicationNo}`);
            }
          });
        },
      })
    );
  };

  /**
   * 戻るボタンを押したときの処理.
   */
  const backOnClick = () => {
    navigator(`/application-status/${applicationNo}`);
  };

  return (
    <SpaceBetween direction={"vertical"} size={"l"}>
      <Container>
        <SpaceBetween direction={"horizontal"} size={"xs"}>
          <SpaceBetween size={"xxs"}>
            <TextContent>
              <h4>{LABELS.CORP_NUMBER}</h4>
            </TextContent>
            <TextContent>
              <h4>{LABELS.COMPANY_NAME}</h4>
            </TextContent>
            <TextContent>
              <h4>{LABELS.COMPANY_ADDRESS}</h4>
            </TextContent>
            <TextContent>
              <h4>{LABELS.MERCHANT_NAME}</h4>
            </TextContent>
          </SpaceBetween>
          <SpaceBetween size={"xxxs"}>
            <TextContent>
              <p>{company?.corporateNumber ?? LABELS.BLANK}</p>
            </TextContent>
            <TextContent>
              <p>{company?.companyName ?? LABELS.BLANK}</p>
            </TextContent>
            <TextContent>
              <p>{company?.address ?? LABELS.BLANK}</p>
            </TextContent>
            <TextContent>
              <p>{company?.merchantName ?? LABELS.BLANK}</p>
            </TextContent>
          </SpaceBetween>
        </SpaceBetween>
      </Container>
      <Container>
        <FormField
          label={LABELS.INCOMPLETION_REASON}
          errorText={incompletionReasonErrorMsg}
        >
          <Textarea
            value={incompletionReason}
            rows={4}
            onChange={({ detail }) => incompletionReasonOnChange(detail.value)}
          />
        </FormField>
      </Container>
      <ColumnLayout columns={2}>
        <Box float={"left"}>
          <Button variant={"link"} onClick={backOnClick}>
            {COMMON_LABELS.BTNS.BACK}
          </Button>
        </Box>
        <Box float={"right"}>
          <Button onClick={registerOnClick} variant={"primary"}>
            {COMMON_LABELS.BTNS.REGISTER}
          </Button>
        </Box>
      </ColumnLayout>
    </SpaceBetween>
  );
};
export default ApplicationIncompletionReasonRegister;
